<app-citizen-header></app-citizen-header>
<div class="w-full h-auto mx-auto bg-white">
  <div class="p-3 md:p-5 flex flex-col md:flex-row justify-start md:justify-between items-start w-11/12 mx-auto">
    <div class="w-full p-4">
      <div class="border-b border-primary-500">
        <app-portal-title-bar [title]="title |concat|translate"></app-portal-title-bar>
      </div>

      <div class="w-full mt-4" *ngIf="privacyPolicyTermsCondition$ |async as data">
        @for (privacy of data; track privacy) {
          <p class="text-md" [innerHtml]="privacy?.content"></p>
        }
      </div>
    </div>
  </div>
</div>
<app-portal-footer></app-portal-footer>

